// extracted by mini-css-extract-plugin
export default {"sideMenuButton":"styles_side-menu-button__GfXU0"};